window.$ = window.jQuery    = require('jquery');
var mask    = require('jquery-mask-plugin');
$.mask      = mask;
window.mask = mask;

export function jqMAsk() {
    
    var maskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
        optionsTelCel = {
            onKeyPress: function (val, e, field, optionsTelCel) {
                field.mask(maskBehavior.apply({}, arguments), optionsTelCel);
            }
        }; 

    $(".phone").mask(maskBehavior, optionsTelCel);
    $('.cep').mask('00000-000');
    $('.cpf').mask('000.000.000-00', {reverse: true});
    $('.cnpj').mask('00.000.000/0000-00', {reverse: true});
}

